export default __webpack_public_path__ + "static/media/heart-yellow.86a7ad12.svg";